import { render, staticRenderFns } from "./MLsportEuropeanMulti.vue?vue&type=template&id=55848fa8&scoped=true"
import script from "./MLsportEuropeanMulti.vue?vue&type=script&lang=js"
export * from "./MLsportEuropeanMulti.vue?vue&type=script&lang=js"
import style0 from "./MLsportEuropeanMulti.vue?vue&type=style&index=0&id=55848fa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55848fa8",
  null
  
)

export default component.exports